
import {useNavigate, useParams} from 'react-router-dom';
import {useState} from "react";
import {articles} from '../articleData/articleData';
import {events} from "../articleData/events";


function Blog() {

    const navigate = useNavigate();
        
    return (
        <div className="layout">
            <button onClick={() => navigate(-1)}>
                Zpět
            </button>

        </div>
    );
}

export default Blog;
